module.exports = __webpack_public_path__ + "balloon.3ac1525febabc61400eb66a2a2e8dfa0.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/img/getting-started/animation/balloon.svg
// module id = 8469278255037467
// module chunks = 1